import { useCallback } from 'react';
import { client } from '../graphql/client';
import { CURRENT_USER_RESOURCE_CODES } from '../graphql/queries/currentUserResourceCodes';
import { getUserInfo } from '../utils/auth';
import { saveUserResourceCodes } from '../utils/resourceAuth';

/**
 * 从服务端获取当前用户资源码列表并写入 localStorage。
 * 接口失败时 throw，由调用方决定如何处理。
 */
export function useFetchResourceCodes() {
    const fetchResourceCodes = useCallback(async (): Promise<string[]> => {
        const userInfo = getUserInfo();
        if (!userInfo?.account?.id) return [];
        const userId = String(userInfo.account.id);

        const result = await client.query<{ currentUserResourceCodes: string[] }>({
            query: CURRENT_USER_RESOURCE_CODES,
            fetchPolicy: 'network-only',
        });

        const codes = result.data?.currentUserResourceCodes ?? [];
        saveUserResourceCodes(userId, codes);
        return codes;
    }, []);

    return { fetchResourceCodes };
}
